export var Heading = {
  baseStyle: {
    letterSpacing: '-0.2px'
  }
};